import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    color: #191A1F;
    text-align: center;
    font-family: "Futura";
    font-size: 36px;
    font-style: normal;
    line-height: 34px;
    letter-spacing: -0.72px;

    @media (min-width: 768px) {
      font-size: 64px;
      font-style: normal;
      line-height: 60px;
      letter-spacing: -1.28px;
    }
  }
`;

export const Title = styled.span<{ $layout: string; }>`
  width: 100%;
  color: #191A1F;
  text-align: center;
  font-family: 'Futura';
  font-size: 128px;
  font-weight: 900;
  margin-bottom: -100px;
  padding: 0;
  opacity: 10%;

    @media (min-width: 768px) {
        font-size: 200px;
        margin-bottom: -150px;
    }

    @media (min-width: 1024px) {
        font-size: 300px;
        margin-bottom: -200px;
    }

  ${({ $layout }) => {
    switch ($layout) {
      case 'Left':
        return `
            @media (min-width: 1024px) {
                z-index: 1;
                position: absolute;
                right: 40%;
                margin-top: 100px;
                margin-bottom: 0px;
                rotate: 90deg;
                font-size: 300px;
            }
        `;
      case 'Right':
        return `
            @media (min-width: 1024px) {
                z-index: 1;
                position: absolute;
                left: 40%;
                margin-top: 100px;
                margin-bottom: 0px;
                rotate: 90deg;
                font-size: 300px;
            }
        `;
      default:
        return '';
    }
  }}
`;


export const Subtitle = styled.h2`
  margin: 0;
  padding: 0;

  @media (min-width: 1024px) {
      width: 600px;
  }
`;

export const Description = styled.p`
  color: #191A1F;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.14px;
`;

export const TextBlock = styled.div<{ $layout: string; }>`
  width: 100%;
  max-width: 450px;
  text-align: center;
  margin-top: 24px;

  a {
    position: relative;
    z-index: 3;
  }

  ${({ $layout }) => {
    switch ($layout) {
    case 'Left':
        return `
            @media (min-width: 1024px) {
                align-self: flex-start;
                text-align: left;
                margin-top: -175px;
            }
        `;
    case 'Right':
        return `
            @media (min-width: 1024px) {
                align-self: flex-end;
                text-align: left;
                margin-top: -175px;
            }
        `;
    default:
        return '';
    }
  }}
`;

export const MediaContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const MainMedia = styled.img`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 436px;
  flex-grow: 1;

  @media (min-width: 1024px) {
    max-width: 872px;
    max-height: 436px;
  }
`;

export const SecondaryMedia = styled.img<{ $layout: string }>`
  width: 100%;
  height: auto;
  max-width: 249px;
  max-height: 377px;
  display: none;
  object-fit: contain;
  // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  flex-grow: 1;

  @media (min-width: 1024px) {
    display: flex;
  }

  ${({ $layout }) => {
    switch ($layout) {
      case 'Left':
        return `
          align-self: flex-end;
          margin-top: -200px;
        `;
      case 'Right':
        return `
          align-self: flex-start;
          margin-top: -200px;
        `;
      default:
        return '';
    }
  }}
`;

export const TertiaryMedia = styled.img<{ $layout: string }>`
  width: 100%;
  height: auto;
  max-width: 458px;
  max-height: 329px;
  display: none;
  object-fit: contain;
  // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  flex-grow: 1;

  @media (min-width: 1024px) {
    display: block;
  }

  ${({ $layout }) => {
    switch ($layout) {
      case 'Left':
        return `
            @media (min-width: 1024px) {
                align-self: flex-end;
                margin-top: -129px;
                margin-right: 50px;
            }
            @media (min-width: 1260px) {
                margin-right: 300px;
            }
        `;
      case 'Right':
        return `
            @media (min-width: 1024px) {
                align-self: flex-start;
                margin-top: -129px;
                margin-left: 50px;
            }
             @media (min-width: 1260px) {
                margin-left: 300px;
            }
        `;
      default:
        return '';
    }
  }}
`;

